import T from 'prop-types'
import { A } from '@patched/hookrouter'

const LinkList = ({ show = false, paths }) => (
  <ul className="m-0 p-0 list-none flex justify-center text-center flex-wrap navbar__links">
    {show && paths.map((i) => (
      <li
        className="inline mr-[1em] cursor-pointer border-r-2 border-blue-600 px-5 navbar__links--item"
        key={i.route}
      >
        <A
          href={`${i.route}`}
          className="text-xl font-normal text-blue-600 no-underline visited:text-blue-600 hover:text-[#f5554f] hover:brightness-110 hover:transition-all hover:duration-300"
        >
          {`${i.label}`}
        </A>
      </li>
    ))}
  </ul>
)

LinkList.propTypes = {
  show: T.bool,
  paths: T.arrayOf(T.shape({
    route: T.string.isRequired,
    label: T.string.isRequired,
  })).isRequired,
}

export default LinkList
